import { CUSTOM_DELIVERY_METHOD } from '../../../../app/spartacus/features/checkout/b2b/core/checkout.model';

export const checkout = {
  shippingPriorities: {
    marathonBestWay: {
      alertInfo: 'Several factors may influence these commitments, so the delivery date cannot be guaranteed.',
      tooltip:
        'Insured and Protected the Marathon’s Best Way Choose Marathon Best Way  and we`ll handle everything for you.  Let us oversee carrier relationships while you enjoy peace of mind with fully insured shipments. If items are damaged or lost, we promptly take corrective actions to resolve the situation, ensuring a worry-free experience for you.',
    },
  },
  checkout: {
    backToCart: 'Back to Cart',
    error: 'Sorry, we were unable to create your order. Please review the data and try again.',
  },
  checkoutProgress: {
    label: 'Checkout Progress',
    deliveryAddress: 'Shipping Information',
    deliveryMode: 'Shipping Priority',
    paymentDetails: 'Payment',
    reviewOrder: 'Review Order',
  },
  checkoutAddress: {
    shippingAddress: 'Shipping Address',
    selectYourDeliveryAddress: 'Select your Shipping Address',
    defaultDeliveryAddress: 'Default Ship-to Address',
    addNewAddress: 'Add Dropshipping Address',
    shipToThisAddress: 'Ship to this address',
    deliveryAddressSelected: 'Delivery address selected',
    modalTitle: 'Change Shipping Address',
    newDropShip: 'New Dropshipping Address',
    company: 'Company',
    street: 'Street',
    city: 'City',
    state: 'State',
    postalCode: 'Postal Code',
    country: 'Country',
    type: 'Type',
    setDefault: 'Set Default',
    shippingPreferences: 'Shipping Preferences',
    noAddressSelected: 'No Address Selected',
    changeShippingAddress: 'Change Shipping Address',
  },
  checkoutMode: {
    deliveryMethod: 'Delivery Method',
    standardDelivery: 'Standard Delivery',
    premiumDelivery: 'Premium Delivery',
    deliveryEntries: 'Items to be Shipped',
    carrier: 'Carrier',
    contractNumber: 'Contract Number',
    shippingAttention: 'Shipping Attention To',
    shippingInstructions: 'Shipping Instructions',
    acknowledgment: 'Acknowledgment',
    selectOption: 'Select an option',
  },
  checkoutReview: {
    review: 'Review Order',
    orderItems: 'Order Items',
    confirmThatRead: 'I confirm that I have read and agree to the',
    placeOrder: 'Place Order',
    termsAndConditions: 'Terms and Conditions',
    editDeliveryAddressDetails: 'Modify delivery address details, opens the Delivery Address page',
    editPaymentDetails: 'Modify payment details, opens the Payment Details page',
    editPaymentType: 'Modify payment method, opens the Payment Information page',
    editDeliveryMode: 'Modify delivery mode, opens the Delivery Mode page',
    orderInProcess: 'Order in process. Please wait.',
  },
  checkoutOrderConfirmation: {
    confirmationOfOrder: 'Order Confirmation:',
    thankYou: 'Thank you for your order!',
    invoiceHasBeenSentByEmail: 'An invoice has been sent by email. You should receive it shortly.',
    orderItems: 'Order Items',
    orderPlacedSuccessfully: 'Order placed successfully',
    createAccount: 'Create an account?',
    createAccountForNext: 'Create an account for <{{email}}> for faster checkout on your next visit.',
  },
  shippingPriority: {
    methods: {
      [CUSTOM_DELIVERY_METHOD.MARATHON_BEST_WAY]: 'Marathon Best Way',
      [CUSTOM_DELIVERY_METHOD.CUSTOMER_SPECIFIED_CARRIER]: 'Customer Specified Carrier',
      [CUSTOM_DELIVERY_METHOD.CUSTOMER_PICKUP]: 'Customer Pickup',
    },
  },
  paymentTypes: {
    title: 'Payment Types',
    paymentType_ACCOUNT: 'Account',
    paymentType_CARD: 'Credit Card',
  },
  checkoutB2B: {
    methodOfPayment: {
      paymentType: 'Payment Type',
    },
    poNumber: {
      label: 'PO Number',
      placeholder: 'Enter your PO number',
      tooltip: 'Your PO# for this order is required.',
    },
    endCustomerPO: {
      label: 'End Customer PO Number',
      placeholder: 'Enter end customer PO number',
      tooltip: 'If you have a PO# for your end customer and would like to record it on this order, please enter here',
    },
    progress: {
      methodOfPayment: 'Payment Information', // Adicione esta linha
    },
  },
  reviewShippingPriority: {
    carrier: 'Carrier',
    contractNumber: 'Contract Number',
    shippingAttention: 'Shipping Attention',
    acknowledgment: 'Acknowledgment',
    shippingInstructions: 'Shipping Instructions',
  },
  reviewShippingInformation: {
    shippingPreferences: 'Shipping Preferences',
    shippingAddress: 'Shipping Address',
  },
  reviewPaymentInfo: {
    methodOfPayment: 'Method of Payment',
    poNumber: 'PO#',
    endCustomerPONumber: 'End Customer PO#',
  },
  reviewOrderDetails: {
    orderDetails: 'Order Details',
    orderNumber: 'Order#',
    date: 'Date',
    status: 'Status',
  },
  reviewItems: {
    items: 'Items',
  },
  reviewBillingInformation: {
    billingInformation: 'Billing Information',
    billingAddress: 'Billing Address',
  },
  reviewAccount: {
    accountDetails: 'Account Details',
    accountNumber: 'Account#',
    accountName: 'Account Name',
  },
  modalAddressConfirmation: {
    confirmYourShippingAddress: 'Please confirm your Shipping Address selection',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
};
